module.exports = __webpack_public_path__ + "medium.svg?bdeb1d004dc4009053b94917afa02958";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medium.svg
// module id = 26
// module chunks = 0